function isValidDate(d) {
  return !isNaN(Date.parse(d))
}

export function dateGreaterThan() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      const validate = function () {
        const startDate = new Date(scope.$eval(attrs.dateGreaterThan))
        const endDate = new Date(ngModel.$viewValue)

        if (!isValidDate(startDate) || !isValidDate(endDate)) return true

        if (!startDate || !endDate) return true

        return endDate > startDate
      }

      scope.$watch(attrs.dateGreaterThan, function () {
        ngModel.$validate()
      })

      ngModel.$validators.dateGreaterThan = function (modelValue) {
        return validate()
      }
    },
  }
}
